
import {zip as observableZip, concat as observableConcat, Observable, PartialObserver, Subscription} from 'rxjs';

import {scan, toArray, share, retryWhen} from 'rxjs/operators';
import * as moment from "moment";
import {HttpClient, HttpHeaders, HttpRequest} from "@angular/common/http";
import {AppConfigurationService} from "../app-config/app-configuration.service";
import {IURIParameter} from "./iuriparameter";
import {LogManager} from "../log/log.manager";
import {LogCat} from "../log/log.categories";
import {Serialization} from "./serialization";
import {Injectable} from "@angular/core";
import {AuthProviderService} from "../../app-auth/services/auth-provider.service";

const NO_CONTENT_CODE = 204;
const NOT_FOUND_CODE = 404;
const INTERNAL_ERROR_CODE = 500;


let propraietrayToJson =function() {
  return moment(this).format('YYYY-MM-DD\\THH:mm:ss.SSS');
};

export class HttpObservable<T> extends Observable<any> {
  subscribe(observerOrNext?:PartialObserver<T> | ((value:T) => void),
            error?:(error) => void, complete?:() => void):Subscription {
    /* tslint:disable */
    return this.subscribe(observerOrNext, error, complete);
    /* tslint:enable */
  }
}

/**
 * a helper utility class for performing REST against our server.
 * the class assumes we are working against a server with our
 * standards - including authentication details, URI standards etc.
 */
@Injectable()
export class HttpWrapper {
  public retryGetDefaults = 3; //todo - get from configuration?
  public retryDetalySec = 1; //todo - get from configuration?
  public maxUrlLength = 2000; //todo - get from configuration?

  constructor(private http: HttpClient,
              private configService: AppConfigurationService,
              private authenticationService: AuthProviderService) {

  }


  /**
   * perform a put request to the server
   * @param ctrl name of controller to access on the server
   * @param func name of function to invoke on the server (including "put" prefix)
   * @param content data to send as part of the reuqest header
   * @param p URI parameters is required
   */
  public put(ctrl:string, func:string, content:any, p?:IURIParameter | IURIParameter[],responseType="json") {
    return this.invoke(ctrl, func, p ? p : [], content, 0, false, 'PUT',responseType);
  }

  public putAnon(ctrl:string, func:string, content:any, p?:IURIParameter | IURIParameter[],responseType="json") {
    return this.invoke(ctrl, func, p ? p : [], content, 0, true, 'PUT',responseType);
  }

  /**
   * perform a post request to the server
   * @param ctrl name of controller to access on the server
   * @param func name of function to invoke on the server (including "put" prefix)
   * @param content data to send as part of the reuqest header
   * @param p URI parameters is required
   */
  public post(ctrl:string, func:string, content:any, p?:IURIParameter | IURIParameter[]) {
    return this.invoke(ctrl, func, p ? p : [], content, 0, false, 'POST');
  }

  /**
   * perform a delete request to the server
   * @param ctrl name of controller to access on the server
   * @param func name of function to invoke on the server (including "put" prefix)
   * @param p URI parameters is required
   */
  public delete(ctrl:string, func:string, p:IURIParameter | IURIParameter[]) {
    return this.invoke(ctrl, func, p,null, 0, false, 'DELETE');
  }

  /**
   * perform a get request from the server
   * @param ctrl name controller to access on the server
   * @param func name of function to access on the server (full name - including "get" prefix if required)
   * @param p parameter(s) to send
   * @param retries number of retries if the request fails
   */
  public get(ctrl:string, func:string, p?:IURIParameter | IURIParameter[], retries?:number, allowCaching?:boolean) {
    return this.invoke(ctrl, func, p ? p : [], null, retries != null ? retries : this.retryGetDefaults, false,
      'GET','json', allowCaching);
  }

  public getBlob(ctrl:string, func:string, p?:IURIParameter | IURIParameter[], retries?:number,
                 anon:boolean = false, cache:boolean = false) {
    return this.invoke(ctrl, func, p ? p : [], null, retries ? retries : this.retryGetDefaults, anon,
      'GET', 'blob', cache);
  }

  public putBlobData(ctrl:string, func:string, content:Blob, p?:IURIParameter | IURIParameter[], anon:boolean = false) {
    return this.invoke(ctrl, func, p ? p : [], content, 0, anon,
      'PUT', undefined, false);
  }

  public putBlob(ctrl:string, func:string,content:any, p?:IURIParameter | IURIParameter[], anon:boolean = false) {
    return this.invoke(ctrl, func, p ? p : [], content, 0, anon,
      'Put', 'blob', false); //notice put instead of PUT (is it a bug?)
  }

  /**
   * perform an ANNONIMIZED get request from the server (do not attach user credentials)
   * @param ctrl name controller to access on the server
   * @param func name of function to access on the server (full name - including "get" prefix if required)
   * @param p parameter(s) to send
   * @param retries number of retries if the request fails
   */
  public getAnon(ctrl:string, func:string, p?:IURIParameter | IURIParameter[], retries?:number) {
    return this.invoke(ctrl, func, p ? p : [], null, retries ? retries : this.retryGetDefaults, true, 'GET');
  }

  /**
   * helper function to perform date construction for date objects.
   * @param raw object to process
   * @param regExp regular expression for names of keys and sub-keys to evaluate
   */
  public parseDates(raw:any, regExp?:RegExp):any {
    let pkg = LogCat.Comm.Proxies;
    let startTime:number;
    if (LogManager.isInfoEnabled(pkg)) {
      LogManager.info(LogCat.Comm.Proxies, "before date parsing");
      startTime = Date.now();
    }
    let ret = Serialization.convertDateStringsToDates(raw, regExp);
    if (LogManager.isInfoEnabled(pkg)) {
      let elapased = Date.now() - startTime;
      LogManager.info(pkg, "after date parsing. elapsed time -", elapased);
    }
    return ret;
  }

  public invoke(ctrl:string, func:string, p:IURIParameter | IURIParameter[], content:any, retries:number,
                anon:Boolean, method:string, responseType:any = 'json', cache:Boolean = false) : Observable<any> {
    let headers = new HttpHeaders();

    // Our server currently does not support xml. Until we enable the server side (if we really want to)
    if (responseType === 'json') {
      headers = headers.set('Accept', 'application/json');
    }

    switch (method) {
      case 'GET':
        // override ie caching
        if (!cache) {
          headers = headers.append("Cache-Control", 'no-cache');
          headers = headers.append("Pragma", 'no-cache');
        }
        break;
      case 'POST':
      case 'PUT':
        if ((content instanceof Blob) || (content instanceof File)){
          let formData:FormData = new FormData();
          formData.append('uploadFile', content);

          content = formData;
        } else {
          if (Date.prototype.toJSON!==propraietrayToJson){
            Date.prototype.toJSON=propraietrayToJson;
          }
          headers = headers.append('Content-Type', 'application/json');
          content = content ? JSON.stringify(content) : null;
        }

        break;
    }

    if (!anon) {
      headers = headers.set("Authorization", "Bearer " + this.authenticationService.currentUserToken.access_token);
    }

    return this.http.request(method, this.getUrl(ctrl, func, p), {
      body: content ? content : null,
      headers, responseType
    }).pipe(
      share(),// especially critical for operations sending stuff to the server;
      retryWhen((errors) => {
        return errors.pipe(scan(function (errorCount:number, err:any) {

          if (err.status === NOT_FOUND_CODE || errorCount >= retries) {
            if (err.status === NOT_FOUND_CODE) {
              LogManager.debug(LogCat.Comm.Proxies, "not found error",err);
            } else {
              LogManager.error(LogCat.Comm.Proxies, "unexpected http error",err);
            }

            throw err;
          }
          return errorCount + 1;
        }, 0));
      }));
  }


  public getUrl(ctrl:string, func:string, p:IURIParameter | IURIParameter[]) : string {
    let arrParams:IURIParameter[];
    if (!p){
      arrParams=[];
    }else if (!Array.isArray(p)) {
      arrParams=[p];
    }else{
      arrParams=p;
    }

    let paramsStr = Serialization.toURLString(arrParams);
    paramsStr = paramsStr ? ("?" + paramsStr) : paramsStr;

    return (this.configService.Config.WebApiUrl + "/" + ctrl + "/" + func + paramsStr);
  }
}
